import { useTranslation } from 'react-i18next'

const Export = () => {
  const { t } = useTranslation()

  const genderOptions = [
    { value: 0, label: t('male') },
    { value: 1, label: t('female') },
    { value: 2, label: t('other') },
  ]

  return genderOptions
}

export default Export
